import Enums from 'utils/EnumsManager';

const { REPORT } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const MOVE_TO_ZONE = `${REPORT}_MOVE_TO_ZONE`;
export const SWAP_CARDS = `${REPORT}_SWAP_CARDS`;
export const RESET_ON_DROP = `${REPORT}_RESET_ON_DROP`;
export const SET_ACTIONS = `${REPORT}_SET_ACTIONS`;
export const SET_MODALE_SORTER_VALUE = `${REPORT}_SET_MODALE_SORTER_VALUE`;
export const RESET_MODALE_SORTER_VALUE = `${REPORT}_RESET_MODALE_SORTER_VALUE`;
export const SET_MODAL_SELECTED_SOTER_ASINITIAL = `${REPORT}_SET_MODAL_SELECTED_SOTER_ASINITIAL`;
export const RESET_MODAL_SORTER = `${REPORT}_RESET_MODAL_SORTER`;
export const SET_MODAL_SOTERS = `${REPORT}_SET_MODAL_SOTERS`;




// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/flow/actionTypes.js